/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ListAzureVirtualNetworks200ResponseVirtualNetworksInner } from '../models/ListAzureVirtualNetworks200ResponseVirtualNetworksInner';

export class ListAzureVirtualNetworks200Response {
  /**
  * The list of virtual networks
  */
  'virtualNetworks': Array<ListAzureVirtualNetworks200ResponseVirtualNetworksInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "virtualNetworks",
      "baseName": "virtualNetworks",
      "type": "Array<ListAzureVirtualNetworks200ResponseVirtualNetworksInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListAzureVirtualNetworks200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

